// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"9610eb8b","977":"089979a3"}[chunkId] + ".chunk.js";
};